:host {
  display: block;
}

svg {
  color: transparent;
  margin: 0px var(--klevu-spacing-xsmall, 2px);
}
.filled {
  fill: #ffd707;
}
